import { render, staticRenderFns } from "./OneTimePasswordPopUp.vue?vue&type=template&id=22ca8d7c&"
import script from "./OneTimePasswordPopUp.vue?vue&type=script&lang=js&"
export * from "./OneTimePasswordPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports